import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'
// 获取oss的token
export function getAliOssKey() {
  return axios.request({
    url: urlObj.oss + '/gateway/v1.0/getAliOssKey',
    method: 'get',
    params: { os: 'oms' }
  })
}
